/* eslint-disable react/no-danger */
import React from 'react';
import { AccordionItem, AccordionHeader, AccordionBody } from '@hz-design-system/web-ui';

interface QuestionProps {
  question: string;
  answer: string;
}

const Question: React.FC<QuestionProps> = ({ question, answer }) => (
  <AccordionItem itemScope={true} itemProp="mainEntity" itemType="https://schema.org/Question">
    <AccordionHeader>
      <span
        itemProp="name"
        className="faqFooter-question"
        dangerouslySetInnerHTML={{
          __html: question,
        }}
      />
    </AccordionHeader>
    <AccordionBody itemScope={true} itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
      <span
        itemProp="text"
        className="faqFooter-answer"
        dangerouslySetInnerHTML={{
          __html: answer,
        }}
      />
    </AccordionBody>
  </AccordionItem>
);

export default Question;
